<template>
  <div class="mb-5">
    <div class="b-form__container_type_flex">
      <checkbox class="b-checkbox" v-model="form.isTermination" @change="changeTerminationState">{{$t('CONTENT.assets.termination')}}</checkbox>
      <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.terminationEvent')" icon="question"></dynamic-icon>
    </div>
    <transition name="fade">
      <div class="my-5 ml-6" v-if="form.isTermination">
        <div>
          <checkbox
            class="b-checkbox"
            :id="`is-termination-${assetComponent.idInDB}`"
            v-model="terminationIsSure"
          >{{$t('CONTENT.assets.options_is_termination')}}</checkbox>
        </div>
        <div class="row mt-5 px-0">
          <div class="col-2 b-form__container_min-width_200">
            <div class="b-form__container">
              <label>{{$t('CONTENT.date')}}:</label>
              <datepicker
                class="b-datepicker"
                key="date"
                v-model="date"
                :formatter="datepickerFormat"
                :disabled="!form.isSure"
                :disabled-date="endAssetComponentDate"
              ></datepicker>
            </div>
          </div>
        </div>
        <div class="mt-5">
          <checkbox
            class="b-checkbox"
            :disabled="!form.isSure"
            :id="`termination-is-fine-presented-${assetComponent.idInDB}`"
            v-model="form.isFinePresented"
          >{{$t('CONTENT.assets.options_is_check_fine')}}</checkbox>
        </div>
        <div class="mt-5">
          <checkbox
            class="b-checkbox"
            :disabled="!form.isFinePresented || !form.isSure"
            :id="`termination-is-fine-will-be-presented-${assetComponent.idInDB}`"
            v-model="form.isFineWillBePayed"
          >{{$t('CONTENT.assets.options_is_check_fine_pay')}}</checkbox>
        </div>
        <!--Данные платежа по штрафу-->
        <div class="my-5" v-if="form.isSure && form.isFinePresented">
          <div class="row mt-5">
            <div class="col-2 b-form__container_min-width_200">
              <div>
                <label>{{$t('CONTENT.payments.payment_currency_code')}}:</label>
                <cool-select
                  :list="currencyCodes"
                  option-value="code"
                  option-text="name"
                  :placeholder="$t('CONTENT.choose')"
                  v-model="currencyCode"
                ></cool-select>
              </div>
            </div>
            <div class="col-2 b-form__container_min-width_200">
              <div class="b-form__container">
                <label for="termination-external-id">{{$t('CONTENT.external_id')}}:</label>
                <input
                  data-cy="termination-external-id"
                  type="text"
                  id="termination-external-id"
                  class="b-input"
                  name="termination-external-id"
                  v-model="form.externalId"
                />
              </div>
            </div>
          </div>
          <div class="mt-5">
            <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
              <div class="col-2 b-form__container_min-width_200" data-cy="termination-lease-rate">
                <label>{{$t('CONTENT.payments.fine_sum')}}:</label>
                <numeric
                  class="b-numeric"
                  controls
                  :min="0"
                  :max="1000000000000"
                  v-model="form.rate"
                  @change="onChangeTerminationRate"
                ></numeric>
              </div>
              <div class="col-2 b-form__container_min-width_200">
                <div>
                  <label>{{$t('CONTENT.payments.payment_date')}}:</label>
                  <datepicker
                    key="paymentDate"
                    class="b-datepicker"
                    v-model="paymentDate"
                    :formatter="datepickerFormat"
                  ></datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import dateConverter from "@/utils/converters/date.converter";
import ExtensionOption from "../../../../../models/contract/ExtensionOption";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  props: {
    assetComponent: {
      required: true,
      type: Object
    },
    form: {
      required: true,
      type: Object
    },
    currencyCodes: {
      required: true,
      type: Array
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      terminationCurrencyCode: null,
      terminationDate: null,
      terminationPaymentDate: null,
    };
  },
  watch: {
    'form.isTermination'(val) {
      if(!val) {
        this.form.isSure = false;
        this.resetTermination();
      }
    },
    'form.isFinePresented'(val) {
      if(!val) {
        this.form.isFineWillBePayed = false;
      }
    }
  },
  created() {
    if(this.form.date != null) {
      this.terminationDate = this.form.date;
    }

    if(this.form.paymentDate != null) {
      this.terminationPaymentDate = this.form.paymentDate;
    }
  },
  computed: {
    date: {
      get() {
        if (this.terminationDate !== null) {
          return dateConverter.convertToDate(this.terminationDate);
        } else {
          return this.terminationDate;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.terminationDate = dateConverter.convertToString(newVal);
          this.form.date = dateConverter.convertToString(newVal);
        } else {
          this.terminationDate = null;
          this.form.date = null;
        }
      }
    },
    terminationIsSure: {
      get() {
        return this.form.isSure;
      },
      set(value) {
        this.form.isSure = value;

        if(!value) {
          this.resetTermination();
        }

        if (value && (this.assetComponent.extension !== null && this.assetComponent.extension.isSure)) {
          this.assetComponent.extension = ExtensionOption.createNew();
        }
      }
    },
    currencyCode: {
      get() {
        if(this.form.currencyCode) {
          return this.form.currencyCode.toLowerCase();
        } else {
          return this.terminationCurrencyCode;
        }
      },
      set(newVal) {
        this.terminationCurrencyCode = newVal.toUpperCase();
        this.form.currencyCode = newVal.toUpperCase();
      }
    },
    paymentDate: {
      get() {
        if (this.terminationPaymentDate !== null) {
          return dateConverter.convertToDate(this.terminationPaymentDate);
        } else {
          return this.terminationPaymentDate;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.terminationPaymentDate = dateConverter.convertToString(newVal);
          this.form.paymentDate = dateConverter.convertToString(newVal);
        } else {
          this.terminationPaymentDate = null;
          this.form.paymentDate = null;
        }
      }
    }
  },

  methods: {
    endAssetComponentDate(date) {
      if (this.assetComponent.endDate !== null) {
        return date > dateConverter.convertToDate(this.assetComponent.endDate);
      }
    },
    onChangeTerminationRate(newVal) {
      this.form.rate = newVal;
    },
    changeTerminationState(e) {
      this.form.isTermination = e;
    },
    resetTermination() {
      this.terminationDate = null;
      this.terminationPaymentDate = null;
      this.form.currencyCode = null;
      this.form.date = null;
      this.form.externalId = null;
      this.form.paymentDate = null;
      this.form.rate = null;
      this.form.isFinePresented = false;
      this.form.isFineWillBePayed = false;
    }
  }
};
</script>
